// transaction_tax.percentage se persiste como fracción (0.02 = 2%).
const PERCENTAGE_MULTIPLIER = 100;
const DECIMALS = 2;

export const formatTaxPercentage = (percentage: number | null | undefined): string => {
  if (percentage == null || Number.isNaN(Number(percentage))) {
    return '-';
  }
  const value = Number(percentage) * PERCENTAGE_MULTIPLIER;
  return `${value.toLocaleString('es-AR', { minimumFractionDigits: DECIMALS, maximumFractionDigits: DECIMALS })}%`;
};

// Las retenciones se descuentan al comercio, por eso se muestran con signo negativo.
export const formatTaxAmount = (currency: string, amount: number, isDeduction: boolean): string => {
  if (isDeduction) {
    return `- ${currency} ${Math.abs(Number(amount)).toFixed(DECIMALS)}`;
  }
  return `${currency} ${Number(amount).toFixed(DECIMALS)}`;
};
